import { createContext } from '@lit/context';

export const dirtyContext = createContext<boolean>('isDirty');
